import NumberFlow from '@number-flow/react'

const PostNumber = ({ value, showZero=false, ...rest }) => (
  <NumberFlow
    value={value}
    continuous
    style={{
      visibility: (value === 0 && !showZero) && 'hidden',
      // gives all numbers equal width to prevent shifting unless number increases in digits
      // (prevents 0-1 from shifting, but not 9-10, for example)
      fontVariantNumeric: 'tabular-nums'
    }}
    spinTiming={{ duration: 150, easing: 'ease-out' }}
    {...rest}
  />
)

export default PostNumber
